import { render, staticRenderFns } from "./PasswordUpdateForm.vue?vue&type=template&id=50269a25&scoped=true&"
import script from "./PasswordUpdateForm.vue?vue&type=script&lang=js&"
export * from "./PasswordUpdateForm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordUpdateForm.vue?vue&type=style&index=0&id=50269a25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50269a25",
  null
  
)

export default component.exports